import React from 'react';
import ReactDOM from 'react-dom';

import MeetingConst from '../../constants/meeting.constants';
import ViewEndPopup from './modals/viewEndPopup';
import DropdownMeetingDate from './dropdownMeetingDate';
import MainMenuTopMeeting from './mainMenuTopMeeting';
import MeetingTimer from './meetingTimer';
import { withTranslation } from 'react-i18next';

// Header Right section
class MeetingTopHeaderRight extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      chekcBoxValue: null,
      printMeeting: this.props.printMeeting,
    };
    this.endMeeting = this.endMeeting.bind(this);
    this.endMeetingOnce = this.endMeetingOnce.bind(this);
    this.reopenMeeting = this.reopenMeeting.bind(this);
    this.setMeetingDate = this.setMeetingDate.bind(this);
  }

  endMeeting(e, future, sendMinute = false) {
    const sendSum = sendMinute ? 1 : 2;
    const { actions } = this.props;

    // TODO: let's refactor this
    delete_meeting_confirm.dialog('open');
    if (document.getElementById('delete-meeting-confirm-box')) {
      ReactDOM.unmountComponentAtNode(document.getElementById('delete-meeting-confirm-box'));
    }
    ReactDOM.render(<ViewEndPopup meetingObj={this.props.meeting} endMeetingOnce={this.endMeetingOnce} future={future} sendSum={sendSum} sendMinute={sendMinute} actions={actions} />, document.getElementById('delete-meeting-confirm-box'));
  }

  endMeetingOnce(checkBoxValues, meetingDeleteConfirm, rate, sendMinute, groupMeeting) {
    const currentServerTime = this.props.current_time;
    const d = new Date();
    const n = d.getTime();
    const { meeting } = this.props;
    const meetingId = meeting.id;
    const typeMeet = meeting.type;
    const futureClose = (currentServerTime < this.props.meeting.sched_at) ? '1' : '0';
    const url = wbConfig.baseUrl + '/meeting/closeMeeting';
    const sendSummary = checkBoxValues;
    $(meetingDeleteConfirm).prop('disabled', true);
    if (typeof url !== 'undefined') {
      $.ajax({
        url,
        type: 'post',
        data: {
          id: meetingId, sendSummary, futureClose, groupMeeting, rate, sendMinute,
        },
      })
        .done((response) => {
          if (response.error) {
            $(delete_meeting_confirm).dialog('close');
            alert(response.error);
          } else {
            $(delete_meeting_confirm).dialog('close');
            let _url = '';
            let containerId = $('.meeting-list-page');
            let leftmenuActive = '';
            if (typeMeet == '1') {
              _url = `${wbConfig.baseUrl}/meeting/1on1smeeting?cs=1`;
              if (typeof getAppContext !== 'undefined' && getAppContext() == 'msteams') {
                _url = `${_url}&from_where=msteams`;
              }
              if ($('.memberPage').length) {
                wbLeftMenuActive(_url);
                return false;
              }
              leftmenuActive = 'meeting_1on1s';
            } else {
              containerId = undefined;
              _url = `${wbConfig.baseUrl}/meeting/index`;
              if (typeof getAppContext !== 'undefined' && getAppContext() == 'msteams') {
                _url = `${_url}?from_where=msteams`;
              }
              leftmenuActive = 'meeting_meetings';
            }
            ajaxPageLoad(_url, undefined, undefined, containerId, 'menu-wb-mymeeting');
            renderLeftMenu('meeting', leftmenuActive);
            if (typeof response.userFavorites !== 'undefined') {
              const favorites = response.userFavorites;
              if (response.userFavorites.length) {
                // TODO: global-level function below?  refactor to handle via action-level function?
                upDateFavorites('meeting', response.userFavorites, '1');
              }
            }
          }
        })
        .fail((response) => {
          alert('Oops something went wrong. Please try again later.');
          $(delete_meeting_confirm).dialog('close');
        });
    }
  }

  reopenMeeting(id) {
    reOpenMeeting(id);
  }

  setMeetingDate(e) {
    const { meeting } = this.props;
    const { currentUser } = this.props;
    const mid = this.props.meeting.id;
    if (meeting.type == '1') {
      editOneOneScheduled(mid, null);
    } else {
      const tid = this.props.meeting.team_id;
      teamMeetingEdit(tid, mid);
    }
  }

  render() {
    const { t } = this.props;
    const { meeting } = this.props;
    const favorites = (this.props.favorites == true) ? 1 : 0;
    const { dateDropdown } = this.props;
    const isTeamManager = (this.props.isTeamManager == true);
    const openMeetingExists = (this.props.openMeetingExists == true);
    const menuOpts = this.props.menuOpts || {};
    const { selectedUser } = this.props;
    const { meeting_topics } = this.props;
    const { meeting_takes } = this.props;
    const { meeting_invitees } = this.props;
    const { printMeeting } = this.state;
    const { userPermission } = this.props;
    const currentServerTime = this.props.current_time;
    let renderIt = null;
    const d = new Date();
    const n = d.getTime();
    const future = (currentServerTime < meeting.sched_at) ? '1' : '0';

    // check meeting is closed
    const enSendMinute = (this.props.meeting.status == 2);
    const currentTime = this.props.current_time;

    if (isTeamManager || userPermission.isAdmin) {
      if (meeting != '') {
        if (meeting.status == 1) {
          if (meeting.sched_at != '' && meeting.sched_at > 0) {
            renderIt = <div className="dispIB paddingTop20 topMenuButtons"><div className="gbl-btn close-meeting-btn" data-close-future={future} onClick={e => this.endMeeting(e, future)} style={{ marginLeft: paddBtnLeft }}>{t('End Meeting')}</div></div>;
          } else if (meeting.sched_at == '' || meeting.sched_at == '0') {
            renderIt = <div className="floatLeft paddingTop20"><input id="set-date-oneonone" onClick={e => this.setMeetingDate(e)} className="set-date-btn clickable" value="Set Date" type="button" /></div>;
          }
        } else if (dateDropdown != null && !openMeetingExists && typeof openMeetingExists !== 'undefined') {
          renderIt = (
            <div className="floatLeft dispIB paddingTop20 topMenuButtons">
              {
                enSendMinute
                && <div className="gbl-btn reopen-meeting-btn floatLeft" onClick={e => this.reopenMeeting(meeting.id)} style={{ paddingLeft: paddBtnLeft, marginLeft: '12px' }}>{t('Reopen')}</div>
              }
            </div>
          );
        }
        if (meeting.status == 2 && meeting.send_minutes == 1) {
          const sendMinute = true;
          renderIt = (
            <div className="floatLeft dispIB" style={{ paddingLeft: '5px', paddingTop: '20px' }}>
              {
                (enSendMinute && meeting.type != 1)
                  ? <div className="sendMinutes floatLeft" onClick={e => this.endMeeting(e, future, sendMinute)} style={{ paddingLeft: paddBtnLeft }}>{t('Send Minutes')}</div>
                  : ''
              }
            </div>
          );
        }
      }
    }

    // TODO!: refactor this inline-style-hack stuff
    let paddLeft = '';
    let paddRightSide = '0px';
    let paddBtnLeft = '0px';
    if (meeting.status == 2 && meeting.type == 1 && meeting.send_minutes == 1) {
      paddLeft = '47%';
      paddBtnLeft = '1%';
    } else if (meeting.status == 2 && meeting.type == 1 && dateDropdown != null && !openMeetingExists && typeof openMeetingExists !== 'undefined') {
      paddLeft = '47%';
      paddBtnLeft = '1%';
    } else if (meeting.status == 2 && meeting.type != 1 && dateDropdown != null && !openMeetingExists && typeof openMeetingExists !== 'undefined') {
      paddLeft = '';
      paddLeft = '2%';
    } else if (meeting.status == 2 && meeting.type != 1 && meeting.send_minutes == 1) {
      paddLeft = '0%';
    } else if (meeting.status == 2 && meeting.type == 1) {
      paddLeft = '47%';
      paddBtnLeft = '1%';
    } else if (meeting.status == 1 && meeting.type == 1) {
      paddLeft = '44%';
      paddBtnLeft = '4%';
      paddRightSide = '10px';
    } else {
      paddLeft = '0%';
    }
    return (
      <div className="width100" style={{ display: 'flex' }}>
        <div className="secondDiv" style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <DropdownMeetingDate meeting={meeting} actions={this.props.actions} dateDropdown={this.props.dateDropdown} paddLeft={paddLeft} paddRightSide={paddRightSide} />
          { meeting.type != 1 ? <MeetingTimer meeting={meeting} actions={this.props.actions} currentUser={this.props.currentUser} userPermission={this.props.userPermission} /> : ''}
          {renderIt}

          <div className="pin pinMeeting floatRight paddingTop20" data-pinstatus={favorites} data-type={MeetingConst.OBJECT_TYPE_MEETING} data-id={meeting.id} data-name={meeting.name} style={{ width: '5%' }} />
          <div className="clear" />
        </div>
        <div className="thirdDiv floatRight paddingTop20">
          <MainMenuTopMeeting
            isTeamManager={isTeamManager}
            meetingObj={meeting}
            openMeetingExists={openMeetingExists}
            dateDropdown={dateDropdown}
            menuOpts={menuOpts}
            meeting={meeting}
            userPermission={this.props.userPermission}
            currentUser={this.props.currentUser}
            selectedUser={selectedUser}
            meeting_topics={meeting_topics}
            meeting_takes={meeting_takes}
            meeting_invitees={meeting_invitees}
            printMeeting={printMeeting}
            actions={this.props.actions}
            currentTime={currentTime}
          />
        </div>
        <div className="clear" />
      </div>
    );
  }
}
export default withTranslation()(MeetingTopHeaderRight);
